












import { computed, defineComponent } from "@vue/composition-api";
import { InputNetBillingCreditCard } from "@scrile/api-provider/dist/api/NetbillingPurchaseProvider";
import { PaymentSystemPublic } from "@scrile/api-provider/dist/api/PaymentSystemsProvider";
import useBeforeUnloadTab from "@/hooks/useBeforeUnloadTab";
import useDarkModeController from "@/hooks/useDarkModeController";
import emitter from "@/lib/emitter";
import { $t } from "@/lib/i18nHelpers";
import { FormValues } from "@/types";
import { EVENTS } from "@/const";
import ModalView from "@/components/ModalView";
import CardEditView from "../../components/CardEditView";

export default defineComponent({
  name: "NetBilling",
  components: { CardEditView, ModalView },
  props: {
    show: { type: Boolean, required: true },
    processing: { type: Boolean, required: true },
    paymentSystem: { type: Object as () => PaymentSystemPublic, required: true },
    isSubscription: { type: Boolean, default: false },
    price: { type: String },
  },
  setup(props, { emit }) {
    const { isDarkMode } = useDarkModeController();
    const logoSrc = computed<string | undefined>(() => {
      return isDarkMode.value ? "/img/cards/netbilling/systems-light.svg" : undefined;
    });
    useBeforeUnloadTab(
      $t("With closing browser tab funds could be billed from your credit card, but the purchase will not happened."),
      computed(() => !props.show)
    );

    const getName = (nameOnCard: string) => {
      const [firstName, ...lastName] = nameOnCard.split(" ");
      return { firstName, lastName: lastName.join(" ") };
    };

    const onSubmit = async ({
      billingDetails,
      cardDetails,
      saveCard,
    }: {
      cardDetails: FormValues;
      billingDetails: FormValues;
      saveCard: boolean;
    }) => {
      const { cardNumber, expireDate, cvc, nameOnCard } = cardDetails;
      const expMonth = expireDate.split("/")[0];
      const expYear = expireDate.split("/")[1];
      const { country, state, city, address, zip } = billingDetails;
      const { firstName, lastName } = getName(nameOnCard);

      if (!lastName) {
        emitter.emit(EVENTS.STATUS_SHOW, { text: "Name on card should contain at least 2 words" });
        return;
      }
      const data: InputNetBillingCreditCard = {
        cardNumber,
        expMonth: Number(expMonth),
        expYear: Number(expYear),
        address,
        cvc,
        country,
        state,
        city,
        zip,
        firstName,
        lastName,
        saveCard,
      };
      emit("submit", data);
    };

    return {
      logoSrc,
      onSubmit,
    };
  },
});
